import React from "react";
import Footer from "../Footer/Footer";
import SimpleHeader from "../NewApp/SimpleHeader";
import "./Coaching.css";
import mixpanel from "../../mixpanel";

const Coaching: React.FC = () => (
  <div className="coaching-wrapper">
    <SimpleHeader />
    <div className="coaching-background">
      <div className="gradient-blob blob-1"></div>
      <div className="gradient-blob blob-2"></div>
    </div>

    <div className="coaching-container">
      <div className="coaching-header">
        <h1 className="coaching-title">Փողային քոուչինգ</h1>
        <p className="coaching-subtitle">
          Մեկ ժամ տևողությամբ օնլայն կրթական հանդիպումներ
        </p>
      </div>

      <div className="coaching-content">
        {/* Topics Section */}
        <div className="coaching-section topics-section">
          <h2 className="section-title">Թեմաներ, որոնցում կարող եմ օգնել</h2>
          <div className="topics-grid">
            <div className="topic-card">
              <div className="topic-icon">📈</div>
              <h3>Ներդրումներ</h3>
              <p>Հասկանալ ֆինանսական մարկետը և սկսել ներդրումներ կատարել</p>
            </div>
            <div className="topic-card">
              <div className="topic-icon">🧠</div>
              <h3>Փողային մտածելակերպ</h3>
              <p>Ձևավորել առողջ հարաբերություններ փողի հետ</p>
            </div>
            <div className="topic-card">
              <div className="topic-icon">💳</div>
              <h3>Պարտքերի կառավարում</h3>
              <p>Կառավարել և ազատվել վարկերից ու պարտքերից</p>
            </div>
            <div className="topic-card">
              <div className="topic-icon">📚</div>
              <h3>Ֆինանսական կրթություն</h3>
              <p>Ռեսուրսներ, գրքեր և սովորելու գործիքներ</p>
            </div>
          </div>
        </div>

        {/* What You Get Section */}
        <div className="coaching-section value-section">
          <h2 className="section-title">Ինչ կստանաք հանդիպումից</h2>
          <div className="value-cards">
            <div className="value-card">
              <div className="value-number">01</div>
              <h3>Անհատական ուշադրություն</h3>
              <p>Ձեր հարցերին և իրավիճակին հատուկ պատասխաններ</p>
            </div>
            <div className="value-card">
              <div className="value-number">02</div>
              <h3>Արագ հասկացողություն</h3>
              <p>Հասկանալ բարդ տերմիները կարճ ժամանակում</p>
            </div>
            <div className="value-card">
              <div className="value-number">03</div>
              <h3>Վստահություն</h3>
              <p>Վստահություն ֆինանսական որոշումներում</p>
            </div>
          </div>
        </div>

        {/* Important Note */}
        <div className="coaching-section note-section">
          <div className="note-card">
            <div className="note-icon">💡</div>
            <div className="note-content">
              <h3>Կարևոր է իմանալ</h3>
              <p>
                Ես հավատում եմ, որ այն ամենը ինչ գիտեմ, պետք է անվճար լինի։ Այդ իսկ պատճառով՝
                ես իմ ամբողջ իմացածով կիսվել, կիսվում և կիսվելու եմ իմ ալիքներում։
                Նոր բաներ պետք չի սպասել քոուչինգից։
              </p>
              <p className="note-highlight">
                Քոուչինգը պարզապես կտա արագ հասկանալու, սովորելու, ավելի վստահ դառնալու հնարավորություն։
                Դուք վճարում եք միայն իմ ժամանակի համար։
              </p>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="coaching-section pricing-section">
          <h2 className="section-title">Արժեքը</h2>
          <div className="pricing-cards">
            <div className="pricing-card main-price">
              <div className="price-header">
                <h3>Ստանդարտ</h3>
                <div className="price">
                  <span className="amount">20,000</span>
                  <span className="currency">դրամ</span>
                </div>
                <p className="price-description">Մեկ ժամ հանդիպում</p>
              </div>
              <div className="price-features">
                <div className="feature">✓ Կրթական բնույթի հանդիպում</div>
                <div className="feature">✓ Անհատական մոտեցում</div>
                <div className="feature">✓ Ձեր հարցերին պատասխաններ</div>
                <div className="feature">✓ Ռեսուրսների ցանկ</div>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="coaching-section disclaimer-section">
          <div className="disclaimer-card">
            <p>
              <strong>Ուշադրություն:</strong> Coaching-ը կրթական բնույթ է կրելու, և ես արտոնություն չունեմ
              Ձեզ ներդրումային խորհրդատվություն տալու։ Ես կարող եմ օգնել, որ դուք ավելի վստահ ու
              ճիշտ ֆինանսական քայլեր կատարեք։
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="coaching-section cta-section">
          <h2 className="section-title">Պատրա՞ստ եք սկսել</h2>
          <p className="cta-description">
            Ամրագրեք Ձեր հանդիպումը և սկսեք Ձեր ֆինանսական ճանապարհորդությունը
          </p>
          <a
            href="https://calendly.com/girlsandfinances"
            target="_blank"
            rel="noopener noreferrer"
            className="coaching-cta-button"
            onClick={() => mixpanel.track("coaching_book_meeting_clicked")}
          >
            Ամրագրել հանդիպում
            <span className="arrow">→</span>
          </a>
        </div>
      </div>
    </div>

    <Footer />
  </div>
);

export default Coaching;
